const ready = require("%helpers%/document-ready.js");

ready(function() {

	const $btnsShowPopups = $(".btn-popup");
	const $elementsHidePopups = $(".popup__close, .popup-message__btn");
	const $allPopups = $(".popup");
	const $page = $("html, body");
	const $scrollHeader = $(".header-scroll");
	const $scrollBg = $(".page-bg");
	const $popupLoadImage = $(".popup-image__img");

	let $curPopup;
	let $curBtn;

	// -- Functions BEGIN
	const loadImage = ($btn) => {
		const src = !!$btn.data("load-src-large-image") ? $btn.data("load-src-large-image") : $btn.data("load-src-image");
		const img = new Image();

		img.onload = function () {
			$popupLoadImage.attr("src", src);
			
			setTimeout(function () {
				$popupLoadImage.parent().addClass("popup-image__wrap-img_onload");
			}, 200);
		};

		img.src = src;
	};

	const showPopup = () => {
		const key = $curBtn.attr("data-popup-key");
		$curPopup = $(`.popup[data-popup-key=${key}]`);
		let pageWidthBeforeFixed = $("body").width();

		if ( $curPopup.length ) {
			if ($curBtn.hasClass("results__slider-item-search-system-wrap-img")) loadImage($curBtn);

			$allPopups.removeClass("popup_visible");
			$curPopup.addClass("popup_visible disabled");
			$page.addClass("page-fixed");

			const pageWidthAfterFix = $("body").width();
			const scrollHeaderIndent = pageWidthAfterFix - pageWidthBeforeFixed;
			$scrollHeader.css({"padding-right": scrollHeaderIndent + "px"});
			$scrollBg.css({"width": `calc(100% - ${scrollHeaderIndent}px)`});
		
			setTimeout(function() {
				$curPopup.removeClass("disabled");
			}, 800); // -- After popups show animation show
		}
	};

	const hidePopups = () => {
		$allPopups.removeClass("popup_visible");

		setTimeout(function() {
			$page.toggleClass("page-fixed");
			$curBtn.removeClass("disabled");
			$scrollHeader.css({"padding-right": 0});
			$scrollBg.css({"width": "100%"});
		}, 800); // -- After popups show animation hide
	};
	// -- Functions END


	// -- Show popop BEGIN
	if ($btnsShowPopups.length && $allPopups.length && $scrollHeader) {
		$btnsShowPopups.on("click", function (e) {
			e.preventDefault();
			$curBtn = $(this).addClass("disabled");
		
			showPopup();
		});
	}
	// -- Show popop END


	// -- Hide popups BEGIN
	if ($elementsHidePopups.length && $allPopups.length && $scrollHeader) {
		$elementsHidePopups.on("click", function () {
			hidePopups();
		});
	}
	// -- Hide popups END

});